"use client";

import { useEffect, useRef, useState } from "react";
import { useLoopVideoBox } from "@/shared/loop-video";
import { TABLET_LOOP } from "../render/media";
import { prefersReducedMotion, useReducedMotion } from "./reduced-motion";

const RISE_AT = 0.35;

/**
 * The administrator on the video-operator tablet rises into place once, when
 * at least 35% of the portrait is first in view (at once with reduced motion,
 * also when it is turned on while the page is open).
 */
export function TabletPortrait() {
  const box = useRef<HTMLDivElement>(null);
  const [risen, setRisen] = useState(false);
  const reducedMotion = useReducedMotion();
  useLoopVideoBox(box);

  useEffect(() => {
    const element = box.current;
    if (!element) return;
    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      const frame = requestAnimationFrame(() => setRisen(true));
      return () => cancelAnimationFrame(frame);
    }
    // Reports also come when observing starts and when the portrait first
    // enters the view, at any ratio, so the ratio itself is checked.
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= RISE_AT)) {
        setRisen(true);
        observer.disconnect();
      }
    }, { threshold: RISE_AT });
    observer.observe(element);
    return () => observer.disconnect();
  }, [reducedMotion]);

  return (
    <div className={risen ? "t-portrait risen" : "t-portrait"} id="tabletPerson" ref={box}>
      <video muted playsInline loop preload="none" poster={TABLET_LOOP.poster}>
        <source src={TABLET_LOOP.webm} type="video/webm" />
        <source src={TABLET_LOOP.mp4} type="video/mp4" />
      </video>
    </div>
  );
}
